import cn from "@utils/cn";
import { getIconProps, isArrayNotEmpty } from "@utils";
import { useFlags } from "@hooks";
import ActionMenu from "@components/action_menu/ActionMenu";

import Icon from "@elements/Icon";
import LinkButton from "@elements/LinkButton";
import Flags from "@elements/Flags";
import Badge from "@elements/Badge";

import "./Card.scss";

const CLASS_NAMES = cn(`
  mb-0
  flex
  h-12
  items-start
  justify-between
  overflow-x-auto
  border-b
  border-[#CCCCCC]
  text-[1.4rem]
  text-[#616161]
  md:text-[1.65rem]
`);

const TITLE_ICON_WRAPPER_CLASS_NAMES = cn(`
  kinn-base-card-header-title-icon-wrapper

  hidden
  md:flex
  items-center
  justify-center
  h-(--icon-wrapper-size)
  w-(--icon-wrapper-size)
  text-(length:--icon-size)
  rounded-[50%]

  bg-(--primary-color)
`);

export default function CardHeader(props) {
  const {
    title,
    icon,
    linkUrl,
    button,
    badge,
    actionMenuItems,

    isAdminOnly,
    isPreview,
  } = props;

  const iconProps = getIconProps(icon, {
    fixedWidth: true,
    color: "#FFFFFF",
  });

  const flags = useFlags([], { isPreview });

  const hasActionMenu = isArrayNotEmpty(actionMenuItems);

  /**************************************************************************************************/

  if (!title) return null;

  return (
    <div className={cn(CLASS_NAMES)}>
      <div className="flex items-center">
        <div className={cn(["kinn-base-card-header-title", "flex items-center gap-3"])}>
          {iconProps && (
            <div className={TITLE_ICON_WRAPPER_CLASS_NAMES}>
              <Icon {...iconProps} />
            </div>
          )}

          {title && (
            <span className="truncate font-medium">
              {title}
              {isAdminOnly && (<span className="font-light">*</span>)}
            </span>
          )}

          <Badge
            value={badge}
            size="md"
          />

          <Flags
            flags={flags}
            flagClassNames="opacity-50"
          />
        </div>
      </div>

      <div className="flex flex-row items-center gap-1.5">
        <div className="kinn-base-card-header-button-wrapper">
          {button}
        </div>

        {linkUrl && (
          <LinkButton
            url={linkUrl}
            iconName="arrow-up-right-from-square"
            isIconOnly={true}
          />
        )}

        {hasActionMenu && (
          <div className="visible-when-not-mobile">
            <ActionMenu items={actionMenuItems} />
          </div>
        )}
      </div>
    </div>
  );
}
